import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-informations-container-block',
  templateUrl: './informations-container-block.component.html',
})
export class InformationsContainerBlockComponent {
  @Input() columns: any;
}
